import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { IUser } from 'types/user';

const getOrganizationUsers = async (organizationId: string): Promise<IUser[]> => {
    const response = await axiosInstance.get<IUser[]>(
        API_ENDPOINTS.ORGANIZATION.USERS(organizationId),
    );
    return response.data;
};

export const useGetOrganizationUsers = (
    organizationId: string,
    options?: Omit<UseQueryOptions<IUser[], Error>, 'queryKey' | 'queryFn'>,
) => useQuery<IUser[], Error>({
    queryKey: [QUERY_KEYS.ORGANIZATION.USERS, organizationId],
    queryFn: () => getOrganizationUsers(organizationId),
    staleTime: Infinity,
    ...(options ?? {}),
});
